import React, { useMemo } from 'react';
import FilterBar from '../Common/FilterBar';
import { useApproval } from '../../DataStore/ApprovalContext';

const LedgerApprovalFilterBar = ({filter}) => {
    const {dispatch, openingDate, closingDate, status} = useApproval();

      // build options once
    const statusOptions = useMemo(
      () => [
        { value: "Pending", label: "Pending" },
        { value: "Approved", label: "Approved" },
        { value: "Rejected", label: "Rejected" },
        { value: "All", label: "All" },
      ],
      []
    );

    const handleFilter = () => {
        filter();
    };

    return (
    <FilterBar
      title="Approval requests"
      subtitle="Click a row to review details before approving."
        //   iconClass="fa fa-receipt"
      controls={[
        {
          type: "dateRange",
          fromValue: openingDate,
          toValue: closingDate,
          onChangeFrom: (e) =>dispatch({ type: 'openingDate', payload: e.target.value }),
          onChangeTo: (e) => dispatch({ type: 'closingDate', payload: e.target.value }),
        },
        {
            type: "select",
            value: status,
            options: statusOptions,
            width: 170,
            onChange: (e) => dispatch({ type: 'status', payload: e.target.value }),
            }
      ]}
      actions={[
        { label: "Apply", iconClass: "fa fa-filter", onClick: handleFilter, variant: "primary" },
      ]}
    />
    );
};

export default LedgerApprovalFilterBar;